import { ArrowUpRight } from "lucide-react";
import { SERVICES, waLink } from "@/lib/site";
import { Reveal, Eyebrow } from "@/components/Reveal";

const ServiceCard = ({ service, index }) => (
  <Reveal delay={(index % 3) * 0.08}>
    <article
      data-testid={`service-card-${service.slug}`}
      className="group rounded-b-3xl rounded-t-[10rem] border border-magenta/15 bg-plum-900/60 p-4 pb-7 transition-all duration-500 hover:-translate-y-2 hover:border-magenta/50 hover:shadow-[0_16px_50px_rgba(217,38,148,0.22)]"
    >
      <div className="overflow-hidden rounded-b-2xl rounded-t-[9rem]">
        <img
          src={service.image}
          alt={`${service.title} at Orchid Vue Spa, Bur Dubai`}
          loading="lazy"
          className="aspect-[3/4] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
        />
      </div>
      <div className="mt-6 flex items-start justify-between gap-3 px-2">
        <span aria-hidden="true" className="font-serif text-xl italic text-[#D85CAB]">
          {String(index + 1).padStart(2, "0")}
        </span>
        <span className="rounded-full border border-champagne/25 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.15em] text-champagne/90">
          {service.duration}
        </span>
      </div>
      <h3 className="mt-3 px-2 font-serif text-2xl font-medium text-cream">
        {service.title}
      </h3>
      <p className="mt-2 px-2 text-sm leading-relaxed text-lavender">
        {service.desc}
      </p>
      <a
        data-testid={`service-book-${service.slug}`}
        href={waLink(
          `Hello Orchid Vue Spa! I'd like to book the ${service.title} (${service.duration}). Please share availability.`
        )}
        target="_blank"
        rel="noopener noreferrer"
        className="mt-5 flex items-center gap-1.5 px-2 text-sm font-semibold text-wa transition-colors duration-300 hover:text-cream"
      >
        Book this ritual
        <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
      </a>
    </article>
  </Reveal>
);

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="mx-auto max-w-7xl px-5 py-24 lg:px-10 lg:py-36"
    >
      <Reveal>
        <Eyebrow>Signature Rituals</Eyebrow>
        <h2 className="mt-4 max-w-2xl font-serif text-2xl font-medium tracking-tight text-cream sm:text-3xl lg:text-4xl">
          Treatments crafted for{" "}
          <span className="italic text-magenta">deep release</span>
        </h2>
        <p className="mt-4 max-w-xl text-base leading-relaxed text-lavender">
          Six signature rituals, each performed in a fully sanitized private
          suite on the 8th floor of Orchid Vue Hotel.
        </p>
      </Reveal>
      <div className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((service, i) => (
          <ServiceCard key={service.slug} service={service} index={i} />
        ))}
      </div>
    </section>
  );
}
